import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { ICommandParameters } from "app/services/authentication/connection/iCommandParameters";
import { ICommandResponse } from "app/services/authentication/connection/iCommandResponse";
import { ErrorDetails } from "app/services/authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";

export class ContractorEmployeesResendInviteCommand extends IRequestCommand<
  IContractorEmployeesResendInviteResponse,
  ErrorDetails,
  IContractorEmployeesResendInviteCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.PUT;
  override _commandUrl = 'contractorEmployees/reSendEmailConfirmation/{contractorEmployeeId}';
  override _needAuthenticate = true;

  public override setParameters(
    params: IContractorEmployeesResendInviteCommandParameters
  ) {
    this._commandUrl = this._commandUrl.replace(
      '{contractorEmployeeId}',
      params.employeeId.toString()
    );
    this._commandBody = params;
  }
}

export interface IContractorEmployeesResendInviteCommandParameters extends ICommandParameters {
  employeeId: number;
}

export interface IContractorEmployeesResendInviteResponse extends ICommandResponse { }
